module.exports = __webpack_public_path__ + "static/media/nf.303ddf97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/nf.png
// module id = 1941
// module chunks = 0